import * as captions from '../sounds/captions/instructions';
import * as spanishCaptions from '../sounds/captions/spanishInstructions';
import AUDIO_INSTRUCTIONS from '../constants/audio';
import thatDidntWorkOne from '../sounds/thatDidntWorkOne.mp3';

import comprehensionCompleteReminder from '../sounds/trcComprehensionCompleteReminder.mp3';
import bookCompleteReminder from '../sounds/trcBookCompleteReminder.mp3';
import troMultiChoiceReadingCheckSentence from '../sounds/troMultiChoiceReadingCheckSentence.mp3';
import fluencyReminder from '../sounds/trcFluencyReminder.mp3';

// Owly audio files
import demoVideoStart from '../sounds/troDemoVideoStart.mp3';
import bookStartGeneral from '../sounds/trcBookStartGeneral.mp3';
import trcMicPermission from '../sounds/trcMicPermission.mp3';
import trcMicTesting from '../sounds/trcMicTesting.mp3';
import trcMicTestRetry from '../sounds/trcTestMicRetry.mp3';
import trcMicTestSuccess from '../sounds/trcMicTestSuccess.mp3';
import trcCountdownReminder from '../sounds/trcCountdownReminder.mp3';
import comprehensionReady from '../sounds/trcComprehensionReady.mp3';
import comprehensionReplay from '../sounds/trcComprehensionReplay.mp3';
import trcMicVerificationFailure from '../sounds/trcMicVerificationFailure.mp3';
import troMicReadingCheck from '../sounds/troMicReadingCheck.mp3';
import troMultiChoiceReadingCheckInstructions from '../sounds/troMultiChoiceReadingCheck.mp3';
import trcReminders from '../sounds/trcReminders.mp3';
import thatDidntWorkTwo from '../sounds/thatDidntWorkTwo.mp3';

// Alex english audio files
import demoVideoStartAlex from '../sounds/TRO_Today_You_Are_Going_To_Read.mp3';
import bookStartGeneralAlex from '../sounds/TRO_Start_Reading_Page_Backup.mp3';
import trcMicPermissionAlex from '../sounds/TRO_Mic_Access.mp3';
import trcMicTestingAlex from '../sounds/TRO_Test_Mic.mp3';
import trcMicTestRetryAlex from '../sounds/TRO_Test_Mic_Try_Again.mp3';
import trcMicTestSuccessAlex from '../sounds/TRO_Test_Mic_Pass.mp3';
import trcCountdownReminderAlex from '../sounds/TRO_Remember_Read_Outloud.mp3';
import comprehensionReadyAlex from '../sounds/TRO_Instructions_For_Questions.mp3';
import comprehensionReplayAlex from '../sounds/TRO_Read_Answer_Questions.mp3';
import trcMicVerificationFailureAlex from '../sounds/TRO_Test_Mic_Not_Reading_Loud_Enough.mp3';
import troMicReadingCheckAlex from '../sounds/TRO_Practice_Reading.mp3';
import troMultiChoiceReadingCheckInstructionsAlex from '../sounds/TRO_Continue_Reading.mp3';
import trcRemindersAlex from '../sounds/TRO_Reminder_Page_Backup.mp3';
import thatDidntWorkTwoAlex from '../sounds/TRO_Test_Mic_Not_Reading_Loud_Enough_Again.mp3';
import comprehensionCompleteReminderAlex from '../sounds/TRO_Done_Answering.mp3';
import bookCompleteReminderAlex from '../sounds/TRO_Done_Reading.mp3';
import troMultiChoiceReadingCheckSentenceAlex from '../sounds/TRO_Red_Bike.mp3';
import fluencyReminderAlex from '../sounds/TRO_Make_Sure.mp3';

// Alex spanish audio files
import demoVideoStartAlexEs from '../sounds/spanish/ES_TRO_Today_You_Are_Going_To_Read.mp3';
import bookStartGeneralAlexEs from '../sounds/spanish/ES_TRO_Start_Reading_Page_Backup.mp3';
import trcMicPermissionAlexEs from '../sounds/spanish/ES_TRO_Mic_Access.mp3';
import trcMicTestingAlexEs from '../sounds/spanish/ES_TRO_Test_Mic.mp3';
import trcMicTestRetryAlexEs from '../sounds/spanish/ES_TRO_Test_Mic_Try_Again.mp3';
import trcMicTestSuccessAlexEs from '../sounds/spanish/ES_TRO_Test_Mic_Pass.mp3';
import trcCountdownReminderAlexEs from '../sounds/spanish/ES_TRO_Remember_Read_Outloud.mp3';
import comprehensionReadyAlexEs from '../sounds/spanish/ES_TRO_Instructions_For_Questions.mp3';
import comprehensionReplayAlexEs from '../sounds/spanish/ES_TRO_Read_Answer_Qestions_PU-01.mp3';
import trcMicVerificationFailureAlexEs from '../sounds/spanish/ES_TRO_Test_Mic_Not_Reading_Loud_Enough.mp3';
import troMicReadingCheckAlexEs from '../sounds/spanish/ES_TRO_Practice_Reading.mp3';
import troMultiChoiceReadingCheckInstructionsAlexEs from '../sounds/spanish/ES_TRO_Continue_Reading.mp3';
import trcRemindersAlexEs from '../sounds/spanish/ES_TRO_Reminder_Page_Backup_PU.mp3';
import thatDidntWorkTwoAlexEs from '../sounds/spanish/ES_TRO_Test_Mic_Not_Reading_Loud_Enough_Again.mp3';
import comprehensionCompleteReminderAlexEs from '../sounds/spanish/ES_TRO_Done_Answering.mp3';
import bookCompleteReminderAlexEs from '../sounds/spanish/ES_TRO_Done_Reading.mp3';
import troMultiChoiceReadingCheckSentenceAlexEs from '../sounds/spanish/ES_TRO_Red_Bike.mp3';
import fluencyReminderAlexEs from '../sounds/spanish/ES_TRO_Make_Sure.mp3';

export const TRC_INSTRUCTIONS = {
    OWLY: {
        demoVideoStart,
        bookStartGeneral,
        trcMicPermission,
        trcMicTesting,
        trcMicTestRetry,
        trcMicTestSuccess,
        fluencyReminder,
        trcCountdownReminder,
        bookCompleteReminder,
        comprehensionReady,
        comprehensionReplay,
        comprehensionCompleteReminder,
        clickOk: AUDIO_INSTRUCTIONS.clickOk,
        troMultiChoiceReadingCheckInstructions,
        troMicReadingCheck,
        troMultiChoiceReadingCheckSentence,
        trcReminders,
    },
    ALEX: {
        demoVideoStart: {
            en: { vo: demoVideoStartAlex, caption: captions.demoVideoStart },
            es: { vo: demoVideoStartAlexEs, caption: spanishCaptions.demoVideoStart },
        },
        bookStartGeneral: {
            en: { vo: bookStartGeneralAlex, caption: captions.bookStartGeneral },
            es: { vo: bookStartGeneralAlexEs, caption: spanishCaptions.bookStartGeneral },
        },
        trcMicPermission: {
            en: { vo: trcMicPermissionAlex, caption: captions.trcMicPermission },
            es: { vo: trcMicPermissionAlexEs, caption: spanishCaptions.trcMicPermission },
        },
        trcMicTesting: {
            en: { vo: trcMicTestingAlex, caption: captions.trcMicTesting },
            es: { vo: trcMicTestingAlexEs, caption: spanishCaptions.trcMicTesting },
        },
        trcMicTestRetry: {
            en: { vo: trcMicTestRetryAlex, caption: captions.trcMicTestRetry },
            es: { vo: trcMicTestRetryAlexEs, caption: spanishCaptions.trcMicTestRetry },
        },
        trcMicTestSuccess: {
            en: { vo: trcMicTestSuccessAlex, caption: captions.trcMicTestSuccess },
            es: { vo: trcMicTestSuccessAlexEs, caption: spanishCaptions.trcMicTestSuccess },
        },
        trcCountdownReminder: {
            en: { vo: trcCountdownReminderAlex, caption: captions.trcCountdownReminder },
            es: { vo: trcCountdownReminderAlexEs, caption: spanishCaptions.trcCountdownReminder },
        },
        comprehensionReady: {
            en: { vo: comprehensionReadyAlex, caption: captions.comprehensionReady },
            es: { vo: comprehensionReadyAlexEs, caption: spanishCaptions.comprehensionReady },
        },
        comprehensionReplay: {
            en: { vo: comprehensionReplayAlex, caption: captions.comprehensionReplay },
            es: { vo: comprehensionReplayAlexEs, caption: captions.comprehensionReplay },
        },
        trcMicVerificationFailure: {
            en: { vo: trcMicVerificationFailureAlex, caption: captions.trcMicVerificationFailure },
            es: { vo: trcMicVerificationFailureAlexEs, caption: spanishCaptions.trcMicVerificationFailure },
        },
        troMicReadingCheck: {
            en: { vo: troMicReadingCheckAlex, caption: captions.troMicReadingCheck },
            es: { vo: troMicReadingCheckAlexEs, caption: spanishCaptions.troMicReadingCheck },
        },
        troMultiChoiceReadingCheckInstructions: {
            en: { vo: troMultiChoiceReadingCheckInstructionsAlex, caption: captions.troMultiChoiceReadingCheckInstructions },
            es: { vo: troMultiChoiceReadingCheckInstructionsAlexEs, caption: spanishCaptions.troMultiChoiceReadingCheckInstructions },
        },
        thatDidntWorkTwo: {
            en: { vo: thatDidntWorkTwoAlex, caption: captions.thatDidntWorkTwo },
            es: { vo: thatDidntWorkTwoAlexEs, caption: spanishCaptions.thatDidntWorkTwo },
        },
        comprehensionCompleteReminder: {
            en: { vo: comprehensionCompleteReminderAlex, caption: captions.comprehensionCompleteReminder },
            es: { vo: comprehensionCompleteReminderAlexEs, caption: spanishCaptions.comprehensionCompleteReminder },
        },
        bookCompleteReminder: {
            en: { vo: bookCompleteReminderAlex, caption: captions.bookCompleteReminder },
            es: { vo: bookCompleteReminderAlexEs, caption: spanishCaptions.bookCompleteReminder },
        },
        fluencyReminder: {
            en: { vo: fluencyReminderAlex, caption: captions.fluencyReminder },
            es: { vo: fluencyReminderAlexEs, caption: spanishCaptions.fluencyReminder },
        },
        troMultiChoiceReadingCheckSentence: {
            en: { vo: troMultiChoiceReadingCheckSentenceAlex, caption: captions.troMultiChoiceReadingCheckSentence },
            es: { vo: troMultiChoiceReadingCheckSentenceAlexEs, caption: spanishCaptions.troMultiChoiceReadingCheckSentence },
        },
        trcReminders: {
            en: { vo: trcRemindersAlex, caption: captions.trcReminders },
            es: { vo: trcRemindersAlexEs, caption: spanishCaptions.trcReminders },
        },
    },
};

export const getTrcInstruction = (isExternalURLSourcePresent, instructionKey, arLanguage = 'en') => {
    if (isExternalURLSourcePresent) {
        if (!TRC_INSTRUCTIONS.ALEX[instructionKey]) return '';
        if (!TRC_INSTRUCTIONS.ALEX[instructionKey][arLanguage]) return '';
        if (!TRC_INSTRUCTIONS.ALEX[instructionKey][arLanguage].vo) return '';
        return TRC_INSTRUCTIONS.ALEX[instructionKey][arLanguage].vo;
    }
    if (TRC_INSTRUCTIONS.OWLY[instructionKey]) {
        return TRC_INSTRUCTIONS.OWLY[instructionKey];
    }
    return '';
};

export const getTrcCaption = (isExternalURLSourcePresent, instructionKey, arLanguage = 'en') => (
    isExternalURLSourcePresent &&
    TRC_INSTRUCTIONS.ALEX[instructionKey] &&
    TRC_INSTRUCTIONS.ALEX[instructionKey][arLanguage] &&
    TRC_INSTRUCTIONS.ALEX[instructionKey][arLanguage].caption
        ? TRC_INSTRUCTIONS.ALEX[instructionKey][arLanguage].caption : ''
);

export const TRC_ERROR_AUDIO = {
    trcMicVerificationFailure,
    thatDidntWorkOne,
    thatDidntWorkTwo,
};

export const STEP_PROGRESS = {
    OFFSET: 1,
    REMINDERS_STEPS_COUNT: 1,
    ONBOARDING_PROGRESS_STEPS_COUNT: 4,
};

export const TRO_MIC_TEST_TEXT = 'The dog likes to play with the ball.';

export const READING_CHECK_WITH_MIC_TEXT = 'I have a pet cat.';

export const READING_CHECK_ANSWER = 'I have a red bike.';

export const READING_CHECK_CHOICES = {
    '0': {
        text: 'I want a red bike.',
        isCorrect: false,
    },
    '1': {
        text: 'I have a red bin.',
        isCorrect: false,
    },
    '2': {
        text: 'I have a big bike.',
        isCorrect: false,
    },
    '3': {
        text: 'I have a red bike.',
        isCorrect: true,
    },
};

export const PRE_ASSESSMENT_STEPS = {
    MIC_CHECK: "mic check",
    READING_CHECK: "reading check",
    DEMO_VIDEO: "demo video",
    BOOK_INTRO: "book introduction"
};
